import { create } from "zustand";

type AuditUiState = {
  eventType: string | undefined;
  resourceType: string | undefined;
  limit: number;
  setEventType: (value: string | undefined) => void;
  setResourceType: (value: string | undefined) => void;
  setLimit: (value: number) => void;
};

export const useAuditUiStore = create<AuditUiState>((set) => ({
  eventType: undefined,
  resourceType: undefined,
  limit: 25,
  setEventType: (value) => set({ eventType: value }),
  setResourceType: (value) => set({ resourceType: value }),
  setLimit: (value) => set({ limit: value }),
}));
